import React from "react";
import { Route } from "react-router";
import NewOrderPage from "pages/OrderPages/NewOrderPage/NewOrderPage";
import BuildOrderPage from "pages/OrderPages/BuildOrderPage/BuildOrderPage";
import ViewPriceEstimatesPage from "pages/OrderPages/ViewPriceEstimatesPage/ViewPriceEstimatesPage";
import NewOrderShippingDetailsPage from "pages/OrderPages/NewOrderShippingDetailsPage/NewOrderShippingDetailsPage";
import NewOrderFormProvider from "pages/OrderPages/NewOrderShippingDetailsPage/contexts/Form/NewOrderFormProvider";
import ReviewOrderPage from "pages/OrderPages/ReviewOrderPage/ReviewOrderPage";
import NewOrderConfirmationPage from "pages/OrderPages/NewOrderConfirmation/NewOrderConfirmation";
import { ProtectedRoute } from "routes/ProtectedRoute";
import { UserNavigationGroup, UserRole } from "types/declarations/enums.ts";

export const NewOrdersRoutes = ProtectedRoute({
	path: "new-order",
	userRolesWithAccess: Object.values(UserRole).filter((role) => role !== UserRole.INTERNAL_DESIGNER),
	blackListNavGroupWithRoles: {
		[UserNavigationGroup.QUOTER]: [UserRole.USER]
	},
	children: (
		<>
			<Route
				index
				element={<NewOrderPage />}
			/>
			<Route
				path="build-order/:draftId?"
				element={<BuildOrderPage />}
			/>
			<Route
				path="view-price-estimates"
				element={<ViewPriceEstimatesPage />}
			/>
			<Route
				path="shipping-details"
				element={
					<NewOrderFormProvider>
						<NewOrderShippingDetailsPage />
					</NewOrderFormProvider>
				}
			/>
			<Route
				path="review-order"
				element={<ReviewOrderPage />}
			/>
			<Route
				path="confirmation"
				element={<NewOrderConfirmationPage />}
			/>
		</>
	)
});
